/**
 * Created by lin on 2017/7/24.
 */
let storageUtil = require("../util/storageUtil");
let util = require("../util/util");
let conf = require("../../config/conf");
let commonAjax = function(data){
    let promise = new Promise( (resolve,reject) => {
        let fn = ()=> {
            if(!data.token){
                data.token = storageUtil.getSession("token");
                if(!data.token){
                    util.gotoLogin();
                    return;
                }
            }

            let arr = data.page.split("/");
            let arrLast = arr[arr.length - 1];
            if(arrLast.search("\\?")){
                arrLast = arrLast.split("?")[0];
            }
            this.$http.post(conf.middleInterfaceUrl + "?" + arrLast, data).then(response => {
                if (response.body) {
                    if (response.body.status === 424) {
                        util.gotoLogin();
                    }
                }
                resolve(response);
            });
        };
        // if(data.needOrg){ //旧的 使用办法
        //     let hasOrgId = ()=> {
        //         // console.log(this.$store.state.userInfo)
        //         if(this.$store.state.userInfo.userOrgId){ //旧的 存的是 clientOrgId
        //             data.orgId = this.$store.state.userInfo.userOrgId;
        //             // console.log(this.$store.state.userInfo)
        //             fn();
        //         }else{
        //             setTimeout(hasOrgId,200);
        //         }
        //     };
        //     hasOrgId();
        // }else{
        //     fn();
        // }

        if(data.needOrg || data.needSubCenterId){ //新的参数获取方式
            let hasOrgId = ()=> {
                if(this.$store.state.userInfo.userOrgId || this.$store.state.userInfo.subCenterId){ //旧的 存的是 clientOrgId
                    if(!data.orgId){
                        data.orgId = this.$store.state.userInfo.userOrgId;
                    }

                    if(!data.subCenterId || !data.centerId){
                        data.subCenterId = this.$store.state.userInfo.subCenterId;
                        data.centerId = this.$store.state.userInfo.subCenterId;
                    }

                    // if(!data.needOrg ){
                    //     delete data.orgId;
                    // }
                    // if(!data.needSubCenterId){
                    //     delete data.subCenterId;
                    //     delete data.centerId;
                    // }
                    fn();
                }else{
                    setTimeout(hasOrgId,200);
                }
            };
            hasOrgId();
        }else{
            fn();
        }



    });
    return promise;
};
module.exports = commonAjax;



// WEBPACK FOOTER //
// ./public/js/service/commonAjax.js